import React from 'react';
import { StarIcon, QuoteIcon } from 'lucide-react';
export function TestimoniosSection() {
  const testimonials = [{
    text: '"Me dio estructura y me organizó todo el año de Lengua. Ahora tengo las clases armadas y puedo enfocarme en mis alumnos."',
    name: 'María Fernanda López',
    role: 'Docente de Lengua y Literatura',
    location: 'Buenos Aires'
  }, {
    text: '"Empecé el ciclo lectivo con todo listo. Los cuadernillos por año son súper prácticos y bien organizados."',
    name: 'Carolina Beatriz Ruiz',
    role: 'Profesora de Lengua',
    location: 'Córdoba'
  }, {
    text: '"Es práctico, claro y muy completo. Lo adapté a mi planificación provincial sin problemas. Mis alumnos participan mucho más."',
    name: 'Luciana Gómez',
    role: 'Docente de secundaria',
    location: 'Rosario'
  }, {
    text: '"Como coordinadora del área, lo compré para todo el equipo de Lengua. Nos ahorró semanas de planificación."',
    name: 'Paula Martínez',
    role: 'Coordinadora de Lengua',
    location: 'Mendoza'
  }, {
    text: '"Siendo estudiante de profesorado, este kit me dio una base sólida para mis prácticas. Lo recomiendo totalmente."',
    name: 'Valentina Sánchez',
    role: 'Estudiante de profesorado',
    location: 'La Plata'
  }];
  return <section id="testimonios" className="py-5 sm:py-14 bg-transparent border-t border-gray-800" data-id="element-309">
      <div className="max-w-5xl mx-auto px-3 sm:px-6" data-id="element-310">
        <div className="text-center mb-4 sm:mb-8" data-id="element-311">
          <h2 className="text-xl sm:text-3xl md:text-4xl font-bold text-white mb-1.5 sm:mb-3" data-id="element-312">
            Testimonios de <span className="text-[#D4A843]" data-id="element-313">docentes</span>
          </h2>
          <p className="text-gray-400 text-sm sm:text-base" data-id="element-314">
            Lo que dicen quienes ya están usando el kit en sus aulas
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4" data-id="element-315">
          {testimonials.map((t, i) => <div key={i} className="bg-[#1a1512] p-4 sm:p-5 rounded-xl border border-gray-700 relative hover:border-[#D4A843]/40 transition-colors" data-id="element-316">
              <QuoteIcon className="absolute top-3 right-3 text-gray-600 h-5 w-5 opacity-30" data-id="element-317" />
              <div className="flex gap-0.5 mb-2" data-id="element-318">
                {[...Array(5)].map((_, s) => <StarIcon key={s} className="h-3.5 w-3.5 text-[#D4A843] fill-current" data-id="element-319" />)}
              </div>
              <p className="text-gray-200 text-sm sm:text-base italic mb-3 leading-relaxed" data-id="element-320">
                {t.text}
              </p>
              <div className="mt-auto" data-id="element-321">
                <p className="text-white font-bold text-sm" data-id="element-322">{t.name}</p>
                <p className="text-[#E8C547] text-xs" data-id="element-323">{t.role}</p>
                <p className="text-gray-500 text-[11px] mt-0.5" data-id="element-324">{t.location}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}